import React, { Component , useEffect } from "react";
import { Link } from 'react-router-dom';
import Header from './Header';
import Loader from './Loader';
import Menu from './Menu';
import NextPrev from "./NextPrev";
import $ from "jquery";
import '../assets/css/question.css';
import { CONFIG ,encryptPHI,decryptPHI} from '../helpers/Common';

class CheifComplainLocation extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            complainDetails:this.props.getComplainData.complainTypeDetails,
            imageView:"front",
            currentImage:"",
            coordinate_x:"",
            coordinate_y:"",isInit:true,
            nextStep:4,
            prevStep:2,
            imgPath: CONFIG.COMPLAIN_IMAGE_PATH,
            selectedLocation:[],
            getComplainLocationData: this.props.getComplainLocationData
        };
        this.handlePrevAction   = this.handlePrevAction.bind(this);
        this.handleAction       = this.handleAction.bind(this);
        this.markPositionOld    = this.markPositionOld.bind(this);

    }

    componentWillMount() {

        // if(localStorage.getItem("data")){

        //     var decryptedData = decryptPHI(CONFIG.ENCRYPTION_KEY,localStorage.getItem("data"));

        //     let data=JSON.parse(decryptedData);  
        //     console.log('data after modification',data)
        //     Object.values(data).forEach((item,key)=>{

        //         if(parseInt(this.props.getComplainData.complain_types) === parseInt(item.complain_type)){
        //             console.log("Item to be stored in data EDIT", item.complainLocationData)
        //             this.props.setComplainLocation(item.complainLocationData);
        //             // this.state.getComplainLocationData = item.complainLocationData;
        //             console.log('get after setter/(Edit): ',this.props.getComplainLocationData)

        //         }

        //     })

        // }else{

        // }

        localStorage.setItem('saveQuest',true)

        let complainData            = this.state.complainDetails;
        let complainLocationData    = this.props.getComplainLocationData; //this.state.getComplainLocationData;

        if(complainLocationData)
        {
            console.log('at complainLocation the getter Data',complainLocationData)
            this.setState({
                coordinate_x    :complainLocationData.coordinate_x,
                coordinate_y    :complainLocationData.coordinate_y,
                imageView       :complainLocationData.image_view,
                currentImage    :complainLocationData.image,
                picCoordinates  :complainLocationData.picCoordinates
            });

        }
        else
        {
            this.setState({
                currentImage    :complainData.image_front,
            });
        }
        this.resize();
    }

    // UNSAFE_componentWillReceiveProps(){
    //     console.log('UNSAFE_componentWillReceiveProps : ',this.props.getComplainLocationData)

    //     this.setState({
    //         getComplainLocationData : this.props.getComplainLocationData, 
    //     });
    // }
    handleImageView = (e)=>{
        if(this.state.imageView=='front')
        {
            this.setState({
                imageView :'back',
                currentImage    : this.state.complainDetails.image_back,
            });
        }
        else
        {
            this.setState({
                imageView :'front',
                currentImage    : this.state.complainDetails.image_front,
            });
        }
        $(".marker").remove();
        this.setState({
            coordinate_x:'',
            coordinate_y:'',
        })
    }

    handleAction = (e)=>{

        if(this.state.selectedLocation === undefined || this.state.selectedLocation.length == 0)
        {
            alert("Please select area in Image");
        }
        else
        {
            $(".marker").remove();
            let data = ({
                image_view      : this.state.imageView,
                image           : this.state.currentImage,
                selectedLocation: this.state.selectedLocation,
                coordinate_x    : this.state.coordinate_x,
                coordinate_y    : this.state.coordinate_y,
            });
            $(".marker").remove();

            console.log('In cheif complain Location the setter data is',data);
            this.props.setComplainLocation(data);
            this.props.handleNextPrev(this.state.nextStep);
        }
        $(".marker").remove();

    }
    handlePrevAction = (e)=>{
        this.props.handleNextPrev(this.state.prevStep);
        $(".marker").remove();
    }

    changeImage = () => {
        $(".marker").remove();
        let tempImage = !this.state.frontImage;
        this.setState({
          frontImage: tempImage
        });
    };

    resize = () => {

        // if(this.state.coordinate_x !== "" || this.state.coordinate_y !== "") this.markPositionOld();

        if(this.state.selectedArray === undefined || this.state.selectedArray.length == 0){

        }else{
            this.markPositionOld();
        }
    };

    componentDidMount() {
        this.resize();
        window.addEventListener('resize', this.resize)

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resize)
    }

    mark(markerId, picCoordinates, top, left) {
        let markerRadius = 13;
        // $(".marker").remove();
        $(".male-img").append(
            $('<div class="marker marker'+ markerId + '"></div>').css({
                position: "absolute",
                top: `calc(${top}px - (${markerRadius}px / 2))`,
                left: `calc(${left}px - (${markerRadius}px / 2))`,
                width: markerRadius + 'px',
                height: markerRadius + 'px',
                backgroundColor: "#990000",
                borderRadius: '50%',
                display: 'inline-block',
            })
        );
    }

    markPositionOld = () => {
        // var picCoordinates = document.getElementById('pic').getBoundingClientRect();
        // this.mark(picCoordinates, this.state.coordinate_y, this.state.coordinate_x);

            var picCoordinates = $('#pic').parent('.male-img')[0].getBoundingClientRect();
            this.state.selectedLocation.map((item)=>{
                return(this.mark(item.picCoordinates, item.coordinate_y, item.coordinate_x));
            });
    };

    markPosition = ev => {
        var picCoordinates = $('#pic').parent('.male-img')[0].getBoundingClientRect();
        let offsetX = ev.pageX - picCoordinates.x;
        let offsetY = ev.pageY - picCoordinates.y;
        // this.mark(picCoordinates, offsetY, offsetX);
        this.setState({
            coordinate_x: offsetX,
            coordinate_y: offsetY,
        });

        this.setState({...this.state,selectedLocation:[...this.state.selectedLocation,this.setNewSelectedLocation(picCoordinates,offsetX,offsetY,this.makeSelectedItemId(this.state.selectedLocation))]});
    };

    setNewSelectedLocation=(picCoordinates,x,y,id)=>{

        return (
            {
                id,
                picCoordinates,
                coordinate_x:x,
                coordinate_y:y,
            }
        );

    };

    makeSelectedItemId=(selectedArray)=>{

        if (selectedArray === undefined || selectedArray.length == 0) {
            return 1;
        }else{
            return  selectedArray[selectedArray.length-1].id +1;
        }
    };

    makeSeletedItemList=(selectedArray)=>{
        if (selectedArray === undefined || selectedArray.length == 0) {
            return null;
        }else {
            return (selectedArray.map((item) => {
                this.mark(item.id, item.picCoordinates, item.coordinate_y, item.coordinate_x);
                return (<div className="point-close"><div>POINT {item.id}</div>
                    <span onClick={(event) => {
                        $(".marker" + item.id).remove();
                        this.setState({
                            ...this.state, selectedLocation: this.state.selectedLocation.filter((i) => {
                                return item.id !== i.id;
                            })
                        });
                    }}>&#10060;</span></div>)
            }));
        }
    };


    render() {

        if(this.state.isInit){
            if(this.props.getComplainLocationData.selectedLocation === undefined || this.props.getComplainLocationData.selectedLocation.length == 0){}else{
                this.setState({...this.state,selectedLocation:this.props.getComplainLocationData.selectedLocation,isInit:false});
            }
        }

    return (

        <React.Fragment>
            <Header title="Patient Symptoms Narrative" titleImage="ic-medical-result.png" />
            <Menu />
            <section className="chief-complain sec--question">
                <div className="questionrow">
                    <div className="question">
                        <label>Question</label>
                        <h3>What is the location of {this.state.complainDetails.name}?</h3>
                    </div>
                </div>
                <div className="male-model-complain">
                    <div className="container">
                        <div className="male-img">
                            <img  onClick={this.markPosition} id="pic" src={this.state.imgPath+this.state.currentImage} alt=""/>
                            {/* <div className="view-btn">
                                <Link to="#" onClick={this.handleImageView} >
                                    <img src={require("../assets/img/icons/ic-refresh.png")} alt=""/>
                                </Link>     
                            </div> */}

                                <div style={{ position: "absolute", top: 10, left: "100%", marginLeft: 15 }}>
                                    {this.makeSeletedItemList(this.state.selectedLocation)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <NextPrev handleNextAction={this.handleAction} next={this.state.nextStep} prev={this.state.prevStep} handlePrevAction={this.handlePrevAction} />

            </React.Fragment>
        );
    }
}

export default CheifComplainLocation;